import { ChevronDownIcon, PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useSelector } from 'react-redux';

const QuoteInformationCardRow = ({ editing, type, heading }) => {
  const data = useSelector((state) =>
    state.quoteReducer?.quote?.[type]?.data?.find(
      (item) => item.heading === heading,
    ),
  );

  return (
    <div key={data?.heading} className="grid grid-cols-4 mt-5 items-center">
      <div className="text-black text-[18px] text-left font-bold">
        {data?.heading} :
      </div>
      <div className="col-span-3 flex flex-row flex-wrap justify-between">
        <div className="text-black text-[16px] text-left items-center hover:cursor-default">
          {data?.value?.join(', ')}
        </div>
        {editing &&
          (data?.heading === 'Quantity' ? (
            <PencilIcon className="h-6 w-6 hover:cursor-pointer" />
          ) : (
            <ChevronDownIcon className="h-6 w-6 hover:cursor-pointer" />
          ))}
      </div>
    </div>
  );
};

export default QuoteInformationCardRow;
